import { styled } from '@mui/material/styles'
import React from 'react'
import { AppBar, UserMenu } from 'react-admin'
import { ReactComponent as Logo } from '../assets/logo.svg'
import LanguageToggler from './config/LanguageToggler'

const PREFIX = 'CustomAppBar'

const classes = {
  title: `${PREFIX}-title`,
}

const StyledAppBar = styled(AppBar)({
  [`& .${classes.title}`]: { flex: 1 },
})

// const ConfigurationMenu = forwardRef((props:MenuItemLinkProps, ref:any) => {
//   const translate = useTranslate()
//   return (
//     <MenuItemLink
//       ref={ref}
//       primaryText={translate('pos.settings')}
//       leftIcon={<SettingsIcon />}
//       {...props}
//       to="/settings"
//     />
//   )
// })

const CustomUserMenu = () => <UserMenu>{/* <ConfigurationMenu /> */}</UserMenu>

const KAppBar = (props: any) => {
  return (
    <StyledAppBar {...props} userMenu={<CustomUserMenu />}>
      <Logo className={classes.title} />
      <LanguageToggler />
    </StyledAppBar>
  )
}

export default KAppBar
// link example to react-admin/layout/AppBar.tsx https://github.com/marmelab/react-admin/blob/master/examples/demo/src/layout/AppBar.tsx
